import React from 'react';

import { Modal, Box } from '@mui/material';
import cn from 'clsx';
import PropTypes from 'prop-types';

import styles from './modal.module.css';

function BasicModal({
    open,
    onClose,
    children,
    className,
    /* some forms open as modal in mobile view it required to be shown in fullscreen, this optional prop make is fullscreen if required */
    mobileFullScreen,
    disableBackdropClick = false,
}) {
    const handleModalClose = (event, reason) => {
        if (disableBackdropClick && reason === 'backdropClick') {
            return;
        }
        onClose(event, reason);
    };

    return (
        <Modal
            open={open}
            onClose={handleModalClose}
            className={styles.modalContainer}
            disableEnforceFocus
        >
            <Box
                className={cn(
                    styles.modalInnerContainer,
                    mobileFullScreen && styles.modalMobileFullScreen,
                    className
                )}
            >
                {children}
            </Box>
        </Modal>
    );
}

BasicModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
    mobileFullScreen: PropTypes.bool,
    disableBackdropClick: PropTypes.bool,
};

export default BasicModal;
